module.exports = __webpack_public_path__ + "media/src/images/bg/bg7-26ceb79f0263d74cd1b384d295e4b551.jpg";